'use strict';

exports.__esModule = true;
var theme = {
  // Primary
  green: '#3CE35F',
  navy: '#212339',

  // Secondary
  cyan: '#4AC7D6',
  gold: '#F6BD04',
  greenDark: '#0ED135',
  greenLight: '#5EEF77',
  navyDark: '#121320',
  navyLight: '#373951',
  red: '#FC4545',
  redDark: '#D43737',

  // Greyscale
  grey: '#A9ABB3',
  greyDark: '#565A5C',
  greyMedium: '#d9d9d9',
  greyLight: '#E4E4E7',
  offWhite: '#F7F7F7',
  white: '#fff',

  // New theme
  midnight600: '#1D004B',
  midnight500: '#23005B',
  midnight400: '#4B2E78',
  midnight50: '#f1f1fe',

  cornFlower500: '#6C65F7',

  sunflower800: '#745F00',
  sunflower600: '#D1AC00',
  sunflower500: '#FFD100',
  sunflower50: '#FFFAE7',

  sky500: '#46E1F5',

  peach500: '#FF847C',

  ghost300: '#F4F6FC',
  ghost200: '#F9FAFD',

  slate200: '#C4BFCC',
  slate300: '#ADA6B8',
  slate500: '#7f7490'
};

exports.default = theme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/styles/theme.js
// module id = 88
// module chunks = 0